const ssn = {
  ssn: {
    value: "",
    dbqName: "form1[0].#subform[0].#subform[1].SSN[0]",
  },
  examDate: {
    value: "",
    dbqName: "form1[0].#subform[0].#subform[1].DateOfExam[0]",
  },
  docName: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[1]",
  },
  docArea: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[6]",
  },
  docDate: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[7]",
  },
  docNpi: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[3]",
  },
  docPhone: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[2]",
  },
  docLicenseNo: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[4]",
  },
  docAddress: {
    value: "",
    dbqName:
      "form1[0].#subform[24].#subform[25].SectionXXI-ExaminersCertSign[0].TextField8[5]",
  },
  diagnosisDate: [
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses1[0]",
      sides: {
        right: "form1[0].#subform[5].SideR1[0]",
        left: "form1[0].#subform[5].SideL1[0]",
        both: "form1[0].#subform[5].SideB1[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis1[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis1[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses10[0]",
      sides: {
        right: "form1[0].#subform[5].SideR10[0]",
        left: "form1[0].#subform[5].SideL10[0]",
        both: "form1[0].#subform[5].SideB10[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis10[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis10[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses2[0]",
      sides: {
        right: "form1[0].#subform[5].SideR2[0]",
        left: "form1[0].#subform[5].SideL2[0]",
        both: "form1[0].#subform[5].SideB2[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis2[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis2[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses3[0]",
      sides: {
        right: "form1[0].#subform[5].SideR3[0]",
        left: "form1[0].#subform[5].SideL3[0]",
        both: "form1[0].#subform[5].SideB3[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis3[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis3[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses4[0]",
      sides: {
        right: "form1[0].#subform[5].SideR4[0]",
        left: "form1[0].#subform[5].SideL4[0]",
        both: "form1[0].#subform[5].SideB4[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis4[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis4[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses5[0]",
      sides: {
        right: "form1[0].#subform[5].SideR5[0]",
        left: "form1[0].#subform[5].SideL5[0]",
        both: "form1[0].#subform[5].SideB5[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis5[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis5[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses6[0]",
      sides: {
        right: "form1[0].#subform[5].SideR6[0]",
        left: "form1[0].#subform[5].SideL6[0]",
        both: "form1[0].#subform[5].SideB6[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis6[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis6[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses7[0]",
      sides: {
        right: "form1[0].#subform[5].SideR7[0]",
        left: "form1[0].#subform[5].SideL7[0]",
        both: "form1[0].#subform[5].SideB7[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis7[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis7[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses8[0]",
      sides: {
        right: "form1[0].#subform[5].SideR8[0]",
        left: "form1[0].#subform[5].SideL8[0]",
        both: "form1[0].#subform[5].SideB8[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis8[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis8[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses9[0]",
      sides: {
        right: "form1[0].#subform[5].SideR9[0]",
        left: "form1[0].#subform[5].SideL9[0]",
        both: "form1[0].#subform[5].SideB9[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosis9[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosis9[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses20[0]",
      sides: {
        right: "form1[0].#subform[5].SideR20[0]",
        left: "form1[0].#subform[5].SideL20[0]",
        both: "form1[0].#subform[5].SideB20[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR20[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL20[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses21[0]",
      sides: {
        right: "form1[0].#subform[5].SideR21[0]",
        left: "form1[0].#subform[5].SideL21[0]",
        both: "form1[0].#subform[5].SideB21[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR21[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL21[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses22[0]",
      sides: {
        right: "form1[0].#subform[5].SideR22[0]",
        left: "form1[0].#subform[5].SideL22[0]",
        both: "form1[0].#subform[5].SideB22[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR22[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL22[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses23[0]",
      sides: {
        right: "form1[0].#subform[5].SideR23[0]",
        left: "form1[0].#subform[5].SideL23[0]",
        both: "form1[0].#subform[5].SideB23[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR23[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL23[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses24[0]",
      sides: {
        right: "form1[0].#subform[5].SideR24[0]",
        left: "form1[0].#subform[5].SideL24[0]",
        both: "form1[0].#subform[5].SideB24[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR24[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL24[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses25[0]",
      sides: {
        right: "form1[0].#subform[5].SideR25[0]",
        left: "form1[0].#subform[5].SideL25[0]",
        both: "form1[0].#subform[5].SideB25[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR25[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL25[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses26[0]",
      sides: {
        right: "form1[0].#subform[5].SideR26[0]",
        left: "form1[0].#subform[5].SideL26[0]",
        both: "form1[0].#subform[5].SideB26[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR26[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL26[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses27[0]",
      sides: {
        right: "form1[0].#subform[5].SideR27[0]",
        left: "form1[0].#subform[5].SideL27[0]",
        both: "form1[0].#subform[5].SideB27[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR27[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL27[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses28[0]",
      sides: {
        right: "form1[0].#subform[5].SideR28[0]",
        left: "form1[0].#subform[5].SideL28[0]",
        both: "form1[0].#subform[5].SideB28[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR28[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL28[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses30[0]",
      sides: {
        right: "form1[0].#subform[5].SideR30[0]",
        left: "form1[0].#subform[5].SideL30[0]",
        both: "form1[0].#subform[5].SideB30[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR30[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL30[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses31[0]",
      sides: {
        right: "form1[0].#subform[5].SideR31[0]",
        left: "form1[0].#subform[5].SideL31[0]",
        both: "form1[0].#subform[5].SideB31[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR31[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL31[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses32[0]",
      sides: {
        right: "form1[0].#subform[5].SideR32[0]",
        left: "form1[0].#subform[5].SideL32[0]",
        both: "form1[0].#subform[5].SideB32[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR32[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL32[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses33[0]",
      sides: {
        right: "form1[0].#subform[5].SideR33[0]",
        left: "form1[0].#subform[5].SideL33[0]",
        both: "form1[0].#subform[5].SideB33[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR33[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL33[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses34[0]",
      sides: {
        right: "form1[0].#subform[5].SideR34[0]",
        left: "form1[0].#subform[5].SideL34[0]",
        both: "form1[0].#subform[5].SideB34[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR34[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL34[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses35[0]",
      sides: {
        right: "form1[0].#subform[5].SideR35[0]",
        left: "form1[0].#subform[5].SideL35[0]",
        both: "form1[0].#subform[5].SideB35[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR35[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL35[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses36[0]",
      sides: {
        right: "form1[0].#subform[5].SideR36[0]",
        left: "form1[0].#subform[5].SideL36[0]",
        both: "form1[0].#subform[5].SideB36[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR36[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL36[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses37[0]",
      sides: {
        right: "form1[0].#subform[5].SideR37[0]",
        left: "form1[0].#subform[5].SideL37[0]",
        both: "form1[0].#subform[5].SideB37[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR37[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL37[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses40[0]",
      sides: {
        right: "form1[0].#subform[5].SideR40[0]",
        left: "form1[0].#subform[5].SideL40[0]",
        both: "form1[0].#subform[5].SideB40[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR40[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL40[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses42[0]",
      sides: {
        right: "form1[0].#subform[5].SideR42[0]",
        left: "form1[0].#subform[5].SideL42[0]",
        both: "form1[0].#subform[5].SideB42[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR42[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL42[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses38[1]",
      sides: {
        right: "form1[0].#subform[5].SideR38[1]",
        left: "form1[0].#subform[5].SideL38[1]",
        both: "form1[0].#subform[5].SideB38[1]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR38[1]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL38[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses41[1]",
      sides: {
        right: "form1[0].#subform[5].SideR41[1]",
        left: "form1[0].#subform[5].SideL41[1]",
        both: "form1[0].#subform[5].SideB41[1]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR41[1]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL41[1]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses38[0]",
      sides: {
        right: "form1[0].#subform[5].SideR38[0]",
        left: "form1[0].#subform[5].SideL38[0]",
        both: "form1[0].#subform[5].SideB38[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR38[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL38[0]",
      },
    },
    {
      type: "checkbox",
      dbqName: "form1[0].#subform[5].Diagnoses41[0]",
      sides: {
        right: "form1[0].#subform[5].SideR41[0]",
        left: "form1[0].#subform[5].SideL41[0]",
        both: "form1[0].#subform[5].SideB41[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOfDiagnosisR41[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOfDiagnosisL41[0]",
      },
    },
    {
      type: "text",
      dbqName: "form1[0].#subform[5].DiagnosisOtherText1[0]",
      sides: {
        right: "form1[0].#subform[5].Other1SideR[0]",
        left: "form1[0].#subform[5].Other1SideL[0]",
        both: "form1[0].#subform[5].Other1SideB[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOther1DiagnosisR[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOther1DiagnosisL[0]",
      },
    },
    {
      type: "text",
      dbqName: "form1[0].#subform[5].DiagnosisOtherText2[0]",
      sides: {
        right: "form1[0].#subform[5].Other2SideR[0]",
        left: "form1[0].#subform[5].Other2SideL[0]",
        both: "form1[0].#subform[5].Other2SideB[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOther2DiagnosisR[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOther2DiagnosisL[0]",
      },
    },
    {
      type: "text",
      dbqName: "form1[0].#subform[5].DiagnosisOtherText3[0]",
      sides: {
        right: "form1[0].#subform[5].Other3SideR[0]",
        left: "form1[0].#subform[5].Other3SideL[0]",
        both: "form1[0].#subform[5].Other3SideB[0]",
        rightDateDbqName: "form1[0].#subform[5].DateOther3DiagnosisR[0]",
        leftDateDbqName: "form1[0].#subform[5].DateOther3DiagnosisL[0]",
      },
    },
  ],
};

export default ssn;
